<ng-container *ngIf="imageIcon && !icon; else iconsFile">
	<img src="assets/images/svg-icon/{{ imageIcon }}.svg" />
</ng-container>
<ng-template #iconsFile>
	<ng-container *ngIf="useMine; else default">
		<svg class="stroke-icon">
			<use [attr.xlink:href]="'assets/svg/icon-sprite.svg#' + icon"></use>
		</svg>
	</ng-container>
</ng-template>
<ng-template #default>
	<svg class="stroke-icon" *ngIf="getSvgType(); else fill">
		<use attr.xlink:href="assets/svg/icon-sprite.svg#stroke-{{ icon }}"></use>
	</svg>
	<ng-template #fill>
		<svg class="fill-icon">
			<use attr.xlink:href="assets/svg/icon-sprite.svg#fill-{{ icon }}"></use>
		</svg>
	</ng-template>
</ng-template>
